// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__yiJdt"};